import { ApiClientProvider } from '@portals/sip-client-data/src/general/ApiClient';
import { EstateItem } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { useEffect, useState } from 'react';

import { Logger } from '../../utils';

type Props = {
  estateIds: string[] | null;
};

type Return = {
  estates: EstateItem[];
  isFetching: boolean;
};

export const useFetchEstatesByIds = ({ estateIds }: Props): Return => {
  const [estates, setEstates] = useState<EstateItem[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!estateIds || estateIds.length === 0) {
      setEstates([]);
      return;
    }

    let canceled = false;
    setIsFetching(true);

    ApiClientProvider.getApiClient()
      .getEstates({ estateIds })
      .then((response) => {
        if (!canceled) {
          setEstates(response.estates);
        }
      })
      .catch((e) => Logger.error(e))
      .finally(() => {
        if (!canceled) {
          setIsFetching(false);
        }
      });

    return () => {
      canceled = true;
    };
  }, [estateIds]);

  return { estates, isFetching };
};
